import React, { useEffect } from "react";
import is from "is_js";
import { Outlet, useLocation } from "react-router-dom"; // Add useLocation
import { ToastContainer } from "react-toastify";
import { Chart as ChartJS, registerables } from "chart.js";
import { CloseButton } from "components/common/Toast";
import SettingsToggle from "components/settings-panel/SettingsToggle";
import SettingsPanel from "components/settings-panel/SettingsPanel";
import { useAppContext } from "providers/AppProvider";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import UseerAutoLogout from "UserAutoLogout";
import { useDispatch } from "react-redux"; // Add useDispatch
import { handleResetAll } from "features/preauthorization/config/preauthorizationSlice";
import {
  handlePreauthFormData,
  handleResetCreateClaim,
} from "features/cliams/config/claimSlice";
import { handleResetPatientSearch } from "features/eliglibility/eliglibility-check/config/eligibilityCheckSlice";

ChartJS.register(...registerables);

const App = () => {
  UseerAutoLogout();
  const HTMLClassList = document.getElementsByTagName("html")[0].classList;
  const {
    config: { navbarPosition, theme },
  } = useAppContext();
  const dispatch = useDispatch(); // Initialize Redux dispatch
  const location = useLocation(); // Get current location

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add("windows");
    }
    if (is.chrome()) {
      HTMLClassList.add("chrome");
    }
    if (is.firefox()) {
      HTMLClassList.add("firefox");
    }
    if (is.safari()) {
      HTMLClassList.add("safari");
    }
  }, [HTMLClassList]);

  useEffect(() => {
    if (navbarPosition === "double-top") {
      HTMLClassList.add("double-top-nav-layout");
    }
    return () => HTMLClassList.remove("double-top-nav-layout");
  }, [navbarPosition]);

  useEffect(() => {
    // Check if URL contains "claim," "preauthorization," or "eligibility"
    const path = location.pathname.toLowerCase();
    const shouldReset = !["claim", "preauthorization", "eligibility"].some(
      (keyword) => path.includes(keyword)
    );

    if (shouldReset) {
      dispatch(handleResetAll({ check: "reset" }));
      dispatch(handleResetCreateClaim());
      dispatch(handlePreauthFormData({ check: "reset" }));
      dispatch(handleResetPatientSearch());
    }
  }, [location.pathname, dispatch]); // Depend on pathname and dispatch

  return (
    <>
      <Outlet />
      <SettingsToggle />
      <SettingsPanel />
      <ToastContainer
        closeButton={CloseButton}
        icon={false}
        position="bottom-right"
        autoClose={1500}
        theme="colored"
      />
    </>
  );
};

export default App;
